import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import $ from 'jquery';
extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});


export default {
    name: 'creer-patient-modal',
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: ["type_enreg"],
    data() {
        return {
            type_patient: "non_assure",
            // assur_validite: '',
            // assur_taux_couverture: '',

            assur_selected: "",
            societe_selected: "",
            liste_societes: [],

            loading: false,
            btn_disable: false,
            // nomPatient: "",
            // prenomsPatient: "",
            // agePatient: "",
            // telPatient: "",
            assureur: null,
            ticket: null,
            // sexe: "",
            sexes: [],
            picked_type_client: "",
            picked_choice: "oui",

            new_patient: {
                country_suffix: this.default_country_code,
                le_malade: "",
                l_accompagnant: "",
                la_personne_a_prevenir: "",
                type_patient: "non_assure",
                assur_selected: "",
                societe_selected: "",
                assur_validite: "",
                assur_taux_couverture: "",
                assur_principal_matricule: "",
                assur_principal_nom: "",
                assur_principal_prenom: "",
                assur_principal_sexe: "",
                assur_principal_phone: "",
                malade_matricule: "",
                malade_nom: "",
                malade_prenom: "",
                malade_sexe: "",
                malade_age: "",
                malade_phone: "",
                malade_quartier: "",
                malade_profession: "",
                accompagnant_nom: "",
                accompagnant_prenom: "",
                accompagnant_phone: "",
                accompagnant_filiation: "",
                accompagnant_quartier: "",
                accompagnant_profession: "",
                personne_a_prevenir_nom: "",
                personne_a_prevenir_prenom: "",
                personne_a_prevenir_phone: "",
                personne_a_prevenir_filiation: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_profession: "",
            },


            // Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
            country_code: "",
            malade_country_code: "",
            accompagnant_country_code: "",
            personne_a_prevenir_country_code: "",

            prefered_countries: [this.default_country_code],
            only_countries: ["tg", "bj", "ci", "bf"],

            url_to_go: "",

            is_child_consult: false,
        };
    },

    watch: {
        assur_selected() {
            this.societe_selected = ''
            this.choixAssurance()
        },

        societe_selected() {
            this.new_patient.assur_validite = ''
            this.new_patient.assur_taux_couverture = ''

            console.log(">> ", this.societe_selected)

            if (this.souscripteurs.length > 0) {
                this.choixSociete()
            }

        }
    },

    computed: {
        assurances() {
            return this.$store.getters["assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        },

        patient_created() {
            return this.$store.getters["patient"];
        },

        cons_selected() {
            return this.$store.getters["typeConsSelected"]
        },

        liste_filiation() {
            return this.$store.getters["liste_filiation"];
        },

        patient() {
            return this.$store.getters["patient"];
        },
    },
    mounted() {
        this.new_patient.country_suffix = this.default_country_code
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        if (
            this.cons_selected.consult_name == 'Consultation Pédiatrique' || this.cons_selected.consult_name == 'Pédiatrie' ||
            this.cons_selected.consult_name == 'Consultation Néonatologique' ||
            this.cons_selected.consult_name == 'Consultation d\'allergologie'
        ) {
            this.is_child_consult = true
        }

        this.$store.dispatch('getListeFiliation', { data_type: 'filiation' })

        this.$store.dispatch("getSexes").then((response) => {
            this.sexes = response

            if (this.cons_selected.consult_abr == 'CPN' && this.type_enreg) {
                this.new_patient.malade_sexe = this.sexes.find(el => el.description == "Femme");
            }
        })

        this.$store.dispatch("getAssurances")

        // let assurance_id = 7
        // this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
        //     
        //     this.liste_societes = this.souscripteurs
        // })

    },
    methods: {
        /**
         * Choix entre Patient assuré ou non
         */
        onAssurance() {
            if (this.new_patient.type_patient == 'assure') {
                // Le patient est assuré
                $('.est-assure').fadeIn(500)
            } else {
                // Le patient n'est pas assuré
                $('.est-assure').fadeOut(500)
            }
        },

        choixAssurance() {
            let assurance_id = this.assur_selected.id

            if (assurance_id > 0) {
                this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
                    this.liste_societes = this.souscripteurs
                })
            } else {
                this.liste_societes = []
            }
        },

        choixSociete() {
            if (this.societe_selected.souscripteur != undefined) {
                this.new_patient.assur_validite = this.societe_selected.duree_restante
                this.new_patient.assur_taux_couverture = this.societe_selected.taux_consultation + '%'
            }
        },

        /**
         * Dis si le malade est : 
         * Lui même ou son Conjoint ou encore son enfant
         */

        onMalade(val) {
            if (val == 1) {         //  Il s'agit de Lui-même
                this.new_patient.malade_matricule = this.new_patient.assur_principal_matricule
                this.new_patient.malade_nom = this.new_patient.assur_principal_nom
                this.new_patient.malade_prenom = this.new_patient.assur_principal_prenom
                this.new_patient.malade_sexe = this.new_patient.assur_principal_sexe
                this.new_patient.malade_phone = this.new_patient.assur_principal_phone
                this.new_patient.malade_quartier = this.new_patient.assur_principal_quartier
                this.new_patient.malade_profession = this.new_patient.assur_principal_profession
            }else if(val == 0){
                this.new_patient.malade_matricule = ''
                this.new_patient.malade_nom = ''
                this.new_patient.malade_prenom = ''
                this.new_patient.malade_sexe = ''
                this.new_patient.malade_phone = ''
                this.new_patient.malade_quartier = ''
                this.new_patient.malade_profession
            }
            else {
                this.new_patient.malade_matricule = ''
                this.new_patient.malade_nom = ''
                this.new_patient.malade_prenom = ''
                this.new_patient.malade_sexe = ''
                this.new_patient.malade_phone = ''
                this.new_patient.malade_quartier = ''
                this.new_patient.malade_profession
            }
        },

        onAcompoagnant(selector) {
            let est_identique = document.getElementById(selector);
            if (est_identique.checked) {
                //  Il s'agit de l'assuré principale

                this.new_patient.accompagnant_nom =this.new_patient.assur_principal_nom
                this.new_patient.accompagnant_prenom =this.new_patient.assur_principal_prenom
                this.new_patient.accompagnant_filiation = ""
                this.new_patient.accompagnant_phone =this.new_patient.assur_principal_phone
                this.new_patient.accompagnant_quartier =this.new_patient.assur_principal_quartier;
                this.new_patient.accompagnant_profession =this.new_patient.assur_principal_profession;
            } else {

                this.new_patient.accompagnant_nom = ''
                this.new_patient.accompagnant_prenom = ''
                this.new_patient.accompagnant_sexe = ''
                this.new_patient.accompagnant_phone = ''
                this.new_patient.accompagnant_filiation = ""
                this.new_patient.accompagnant_quartier = ""
                this.new_patient.accompagnant_profession = ""
            }
        },
        onPersonneAprevenir(val) {

            console.log("val: ",val);
            if (val == 0) {         

                 this.new_patient.personne_a_prevenir_nom = "";
                 this.new_patient.personne_a_prevenir_prenom = "";
                 this.new_patient.personne_a_prevenir_phone = "";
                 this.new_patient.personne_a_prevenir_filiation = "";
                 this.new_patient.personne_a_prevenir_quartier = "";
                 this.new_patient.personne_a_prevenir_profession = "";
                //  Il s'agit de l'assuré principale

                
            } else if (val == 1) {

                this.new_patient.personne_a_prevenir_nom =this.new_patient.assur_principal_nom;
                this.new_patient.personne_a_prevenir_prenom =this.new_patient.assur_principal_prenom;
                this.new_patient.personne_a_prevenir_phone =this.new_patient.assur_principal_phone;
                this.new_patient.personne_a_prevenir_quartier =this.new_patient.assur_principal_quartier;
                this.new_patient.personne_a_prevenir_profession =this.new_patient.assur_principal_profession;
              //  Il s'agit de l'accompagnant

             
            } else if (val == 2) {

                 this.new_patient.personne_a_prevenir_nom =this.new_patient.accompagnant_nom;
                 this.new_patient.personne_a_prevenir_prenom =this.new_patient.accompagnant_prenom;
                 this.new_patient.personne_a_prevenir_phone =this.new_patient.accompagnant_phone;
                 this.new_patient.personne_a_prevenir_quartier =this.new_patient.accompagnant_quartier;
                 this.new_patient.personne_a_prevenir_profession =this.new_patient.accompagnant_profession;
                 this.new_patient.personne_a_prevenir_filiation =this.new_patient.accompagnant_filiation;
             
            } else {
              this.new_patient.personne_a_prevenir_nom = "";
              this.new_patient.personne_a_prevenir_prenom = "";
              this.new_patient.personne_a_prevenir_phone = "";
              this.new_patient.personne_a_prevenir_filiation = "";
              this.new_patient.personne_a_prevenir_quartier = "";
              this.new_patient.personne_a_prevenir_profession = "";
            }
        },

        /**
         * Clear Error message
         */
        clearError() {
            this.tel_is_required = false
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
        },

        maladeCountryChanged(country) {
            this.malade_country_code = '+' + country.dialCode
        },

        accompagnantCountryChanged(country) {
            this.accompagnant_country_code = '+' + country.dialCode
        },
        personneAPrevenirCountryChanged(country) {
            this.personne_a_prevenir_country_code = "+" + country.dialCode;
        },

        choosePatient(data) {
            this.$store.dispatch('getPatient', data.id).then(() => {
                const selected_patient = {
                    id: this.patient.id,
                    nom: this.patient.nom+" "+this.patient.prenoms,
                    nom_patient: this.patient.nom+" "+this.patient.prenoms,
                    prenoms: "",
                    sexe: this.patient.sexe.specificatif,
                    telephone_mobile: this.patient.telephone_mobile,
                    age: this.patient.age,
                    num_dossier: this.patient.code
                }
                this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);
            })
        },

        async savePatient() {
            const isValid = await this.$refs.add_patient.validate();

            if (!isValid) {
                return;
            }

            let n_patient = {

            }

            let date_nais = '';
            if (this.new_patient.malade_age.match(/[0-9]+-[0-9]+-[0-9]+/g)) { // si c'est une date de naissance renseignée
                let today = new Date();
                date_nais = this.dateFormatToSend(this.new_patient.malade_age).date

                if (date_nais > today) {
                    this.doErrorMsg("La date de naissance doit être antérieure à la date d'aujourd'hui")
                    return;
                } else {
                    // si tout est correct
                    date_nais = this.dateFormatToSend(this.new_patient.malade_age).date_to_send;
                }
            } else { // si c'est l'âge qui est renseigné
                date_nais = this.new_patient.malade_age;
            }
            let p_tel = (this.new_patient.malade_phone != '') ? (this.malade_country_code + ' ' + this.new_patient.malade_phone) : ''
            let assur_tel = (this.new_patient.assur_principal_phone != '') ? (this.country_code + ' ' + this.new_patient.assur_principal_phone) : ''
            let accompagnant_tel = (this.new_patient.accompagnant_phone != '') ? (this.accompagnant_country_code + ' ' + this.new_patient.accompagnant_phone) : ''
            let personne_a_prevenir_tel = this.new_patient.personne_a_prevenir_phone != "" ? this.personne_a_prevenir_country_code + ' ' + this.new_patient.personne_a_prevenir_phone : '';

            n_patient = {
                country_suffix: this.new_patient.country_suffix,
                le_malade: this.new_patient.le_malade,
                type_patient: this.new_patient.type_patient,
                assur_selected: this.assur_selected.id,
                societe_selected: this.societe_selected.id,
                assur_validite: this.new_patient.assur_validite,
                assur_taux_couverture: this.new_patient.assur_taux_couverture,
                assur_principal_matricule: this.new_patient.assur_principal_matricule,
                assur_principal_nom: this.new_patient.assur_principal_nom,
                assur_principal_profession: this.new_patient.assur_principal_profession,
                assur_principal_quartier: this.new_patient.assur_principal_quartier,
                assur_principal_prenom: this.new_patient.assur_principal_prenom,
                assur_principal_sexe: this.new_patient.assur_principal_sexe.id,
                assur_principal_phone: assur_tel,
                malade_matricule: this.new_patient.malade_matricule,
                nom: this.new_patient.malade_nom,
                prenoms: this.new_patient.malade_prenom,
                sexe: this.new_patient.malade_sexe.id,
                date_naissance: date_nais,
                telephone_mobile: p_tel,
                quartier: this.new_patient.malade_quartier,
                profession: this.new_patient.malade_profession,
                l_accompagnant: this.new_patient.l_accompagnant,
                accompagnant_nom: this.new_patient.accompagnant_nom,
                accompagnant_prenom: this.new_patient.accompagnant_prenom,
                accompagnant_phone: accompagnant_tel,
                accompagnant_quartier: this.new_patient.accompagnant_quartier,
                accompagnant_profession: this.new_patient.accompagnant_profession,
                accompagnant_filiation: this.new_patient.accompagnant_filiation,
                la_personne_a_prevenir: this.new_patient.la_personne_a_prevenir,
                personne_a_prevenir_nom: this.new_patient.personne_a_prevenir_nom,
                personne_a_prevenir_prenom: this.new_patient.personne_a_prevenir_prenom,
                personne_a_prevenir_phone: personne_a_prevenir_tel,
                personne_a_prevenir_filiation: this.new_patient.personne_a_prevenir_filiation,
                personne_a_prevenir_quartier: this.new_patient.personne_a_prevenir_quartier,
                personne_a_prevenir_profession: this.new_patient.personne_a_prevenir_profession,
            };

            this.$store.commit("SET_PATIENT", []);

            this.loading = true

            this.$store.dispatch("createPatient", n_patient).then((response) => {
                console.log(response);
                if (response < 0) {
                    if (response == -1) {
                        this.doErrorMsg("Ce numero de téléphone a déja été pris")
                    } else if (response == -2) {
                        this.doErrorMsg("L'adresse email a déja été prise")
                    }
                } else {
                    this.$nextTick(() => {
                        let data = {
                            id: response.id,
                            nom: response.nom,
                            prenoms: response.prenoms,
                            age: response.age
                        }
                        this.$store.commit("SET_CHOSEN_PATIENT", {});

                        this.$store.dispatch('getPatient', data.id).then(() => {
                            const selected_patient = {
                                id: this.patient.id,
                                nom: this.patient.nom+" "+this.patient.prenoms,
                                nom_patient: this.patient.nom+" "+this.patient.prenoms,
                                prenoms: "",
                                sexe: this.patient.sexe.specificatif,
                                telephone_mobile: this.patient.telephone_mobile,
                                age: this.patient.age,
                                num_dossier: this.patient.code
                            }
                            this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);

                            if (this.type_enreg != 'vente') {
                                const action_selected = this.$store.getters["typeActionSelected"];
                                if (action_selected == "bon_consultation") {
                                    this.url_to_go = { name: 'Bon consultation' }
                                } else {
                                    this.url_to_go = { name: 'Bon medical' }
                                }
                                this.$router.push({
                                    name: this.url_to_go.name,
                                    params: {
                                        assurance_id: (this.assur_selected.id > 0) ? this.assur_selected.id : 0,
                                        societe_id: (this.societe_selected.id > 0) ? this.societe_selected.id : 0,
                                        taux: (this.new_patient.assur_taux_couverture),
                                        validite: this.new_patient.assur_validite
                                    }
                                })
                            }
                        })
                        // this.choosePatient(data)
                        

                        this.$store.dispatch('getPatient', data.id).then(() => {
                            const p_fullname = {
                                patient_nom: this.patient.nom + ' ' + this.patient.prenoms,
                                patient_id: this.patient.id,
                                patient_sexe: this.patient.sexe.specificatif,
                                patient_telephone: this.patient.telephone_mobile,
                                patient_age: this.patient.age,
                                num_dossier: this.patient.code
                            }
                            this.$emit('passNewPatient', p_fullname)
                        })
                        
                        this.doSuccessMsg();

                        (this.new_patient = {
                          le_malade: "",
                          type_patient: "non_assure",
                          assur_selected: "",
                          societe_selected: "",
                          assur_validite: "",
                          assur_taux_couverture: "",
                          assur_principal_matricule: "",
                          assur_principal_nom: "",
                          assur_principal_prenom: "",
                          assur_principal_sexe: "",
                          assur_principal_phone: "",
                          malade_matricule: "",
                          malade_nom: "",
                          malade_prenom: "",
                          malade_sexe: "",
                          malade_age: "",
                          malade_phone: "",
                          malade_quartier: "",
                          malade_profession: "",
                          l_accompagnant: "",
                          accompagnant_nom: "",
                          accompagnant_prenom: "",
                          accompagnant_filiation: "",
                          accompagnant_phone: "",
                          accompagnant_quartier: "",
                          accompagnant_profession: "",
                          la_personne_a_prevenir: "",
                          personne_a_prevenir_nom: "",
                          personne_a_prevenir_prenom: "",
                          personne_a_prevenir_filiation: "",
                          personne_a_prevenir_phone: "",
                          personne_a_prevenir_quartier: "",
                          personne_a_prevenir_profession: "",
                        }),
                          this.$refs.add_patient.reset();
                        this.$refs.close_modal.click();
                    });
                }
                this.loading = false

            }).catch(() => {
                this.loading = false
            })
        },

        doSuccessMsg: function () {
            this.$toasted.show('Le nouveau patient a été ajouté', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function (msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
        dateFormatToSend: function (given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            let date_to_send = `${date.getFullYear()}-${month}-${day}
                                      `;
            return { date: date, date_to_send: date_to_send }
        }

    }
}